import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import ModalContentBase from './modal_content_base';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    hasPayjp: PropTypes.bool.isRequired,
  },
  getInitialState() {
    return {
      cardNumber: '',
      cardHolder: '',
      cardSecurityCode: '',
      cardExpMonth: '',
      cardExpYear: '',
      scene: 1,
      isCardRegistered: false,
      cardErrorMessage: '',
    };
  },
  handleCardNumberForm(e) {
    this.setState({
      cardNumber: e.target.value,
    });
  },
  handleCardHolderForm(e) {
    this.setState({
      cardHolder: e.target.value,
    });
  },
  handleCardSecurityCodeForm(e) {
    this.setState({
      cardSecurityCode: e.target.value,
    });
  },
  handleCardExpMonthSelect(e) {
    this.setState({
      cardExpMonth: e.target.value,
    });
  },
  handleCardExpYearSelect(e) {
    this.setState({
      cardExpYear: e.target.value,
    });
  },
  handleSubmitCreditCard() {
    let cardNumber = this.state.cardNumber;
    let cardSecurityCode = this.state.cardSecurityCode;
    let cardExpMonth = this.state.cardExpMonth;
    let cardExpYear = this.state.cardExpYear;
    var card = {
      number: cardNumber,
      cvc: cardSecurityCode,
      exp_month: cardExpMonth,
      exp_year: cardExpYear,
    };
    Payjp.createToken(
      card,
      function (s, response) {
        if (response.error) {
          this.setState({
            cardErrorMessage:
              'カード情報が正しくありません。再度ご確認の上、正しくご入力ください。',
          });
        } else {
          this.setState({
            cardHolder: '',
            cardSecurityCode: '',
          });
          var token = response.id;
          $.ajax({
            url: '/api/forms/payjp_register',
            type: 'POST',
            cache: false,
            headers: {
              'X-CSRF-Token':
                document.getElementsByName('csrf-token')[0].content,
            },
            data: {
              token: token,
            },
          })
            .done(
              function () {
                this.setState({
                  scene: 2,
                  isCardRegistered: true,
                });
              }.bind(this)
            )
            .fail(
              function () {
                this.setState({});
              }.bind(this)
            );
        }
      }.bind(this)
    );
  },
  handleSceneSwitch() {
    this.setState({
      scene: 1,
    });
  },
  render() {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      months.push(i);
    }
    const monthSelect = months.map(function (month) {
      return (
        <option value={month} key={month}>
          {month}
        </option>
      );
    });
    let years = [];
    const today = new Date();
    let i = today.getFullYear();
    let i2 = i + 10;
    for (i; i <= i2; i++) {
      years.push(i);
    }
    const yearSelect = years.map(function (year) {
      return (
        <option value={year} key={year}>
          {year}
        </option>
      );
    });
    const registerBtn =
      this.state.cardNumber &&
      this.state.cardHolder &&
      this.state.cardSecurityCode &&
      this.state.cardExpMonth &&
      this.state.cardExpYear ? (
        <button
          onClick={this.handleSubmitCreditCard}
          className="btn btn-info w-100"
        >
          登録
        </button>
      ) : (
        <button className="btn btn-info w-100" disabled>
          登録
        </button>
      );

    let previewContent = this.props.hasPayjp ? (
      <div>
        <p>
          <b>使用するカード（登録済みカード）</b>
        </p>
        <p>
          xxxx-xxxx-xxxx-{this.props.payjpLast4} 有効期限:{' '}
          {this.props.payjpExpMonth}/{this.props.payjpExpYear}
        </p>
        <button className="btn btn-default">別のカードを使う</button>
      </div>
    ) : (
      <button className="btn btn-default">カードを登録する</button>
    );

    const modalContent = (
      <div style={{ padding: '25px' }}>
        {this.state.scene == 2 ? (
          <div>
            <p>登録が完了しました。</p>
            <p>枠外をクリックして元の画面に戻ってください。</p>
            <p style={{ textAlign: 'center' }}>または</p>
            <p>
              <button
                onClick={this.handleSceneSwitch}
                className="btn btn-info w-100"
              >
                別のカードを登録し直す
              </button>
            </p>
          </div>
        ) : (
          <div>
            <h2 style={{ marginTop: 0 }}>クレジットカードの登録</h2>
            <div className="alert alert-info mb10" role="alert">
              BASE株式会社のPAY.JPサービスを利用して決済を実行します。
              <br />
              当社では、お客様がクレジットカード登録状況を後から識別するために、有効期限と下４桁と期限のみ保持し、それ以外の情報は破棄しています。
            </div>
            <table className="form-item-form">
              <tr>
                <th>
                  クレジットカード番号{' '}
                  <span className="label label-warning">必須</span>
                </th>
                <td>
                  <input
                    type="number"
                    placeholder="例）4980424242424242"
                    onChange={this.handleCardNumberForm}
                    className="form-control"
                  />
                </td>
              </tr>
              <tr>
                <th>
                  契約者名 <span className="label label-warning">必須</span>
                </th>
                <td>
                  <input
                    type="text"
                    placeholder="例）TARO SUZUKI"
                    onChange={this.handleCardHolderForm}
                    className="form-control"
                  />
                </td>
              </tr>
              <tr>
                <th>
                  セキュリティコード{' '}
                  <span className="label label-warning">必須</span>
                </th>
                <td>
                  <input
                    type="number"
                    placeholder="例）123"
                    onChange={this.handleCardSecurityCodeForm}
                    className="form-control"
                  />
                </td>
              </tr>
              <tr>
                <th>
                  有効期限 <span className="label label-warning">必須</span>
                </th>
                <td>
                  <select
                    className="form-control"
                    onChange={this.handleCardExpMonthSelect}
                  >
                    <option value="">月</option>
                    {monthSelect}
                  </select>
                </td>
              </tr>
              <tr>
                <td>
                  <select
                    className="form-control"
                    onChange={this.handleCardExpYearSelect}
                  >
                    <option value="">年</option>
                    {yearSelect}
                  </select>
                </td>
              </tr>
            </table>
            {this.state.cardErrorMessage ? (
              <p className="mt10 mb10" style={{ color: 'red' }}>
                {this.state.cardErrorMessage}
              </p>
            ) : (
              ''
            )}
            {registerBtn}
          </div>
        )}
      </div>
    );
    if (this.state.isCardRegistered) {
      previewContent = (
        <div>
          <p>
            <strong>使用するカード（登録したカード）</strong>
          </p>
          <p>
            xxxx-xxxx-xxxx-{this.state.cardNumber.slice(12)}&nbsp;有効期限:{' '}
            {this.state.cardExpMonth}/{this.state.cardExpYear}
          </p>
          <button className="btn btn-default">別のカードを使う</button>
        </div>
      );
      return (
        <ModalContentBase
          previewContent={previewContent}
          modalContent={modalContent}
        />
      );
    }
    return (
      <ModalContentBase
        previewContent={previewContent}
        modalContent={modalContent}
      />
    );
  },
});
